import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { ComponentStoreFactory } from '../../../../shared/store/common/component-store.factory';
import { ServiceGridItemObject, ServiceObject } from '@it2go/types';
import { ServiceService } from '../../../../../services/service.service';
import { selectService } from '../../../store/service/service.selectors';
import { Observable } from 'rxjs';

interface State {
    service: ServiceObject | null,
}

const defaultState: State = {
    service: null,
};

@Injectable()
export class ServiceBasicInformationPageStore extends ComponentStoreFactory<State> {

    service$: Observable<ServiceGridItemObject | null> = this.globalStore!.select(selectService);

    constructor() {
        super(defaultState, inject(Store), inject(ServiceService));
    }

}
